import {
  GET_USER_PREFERENCES_INIT,
  GET_USER_PREFERENCES_SUCCESS,
  GET_USER_PREFERENCES_FAILED,
  GET_EMAIL_TEMPLATE_INIT,
  GET_EMAIL_TEMPLATE_SUCCESS,
  GET_EMAIL_TEMPLATE_FAILED,
  CREATE_USER_PREFERENCE_INIT,
  CREATE_USER_PREFERENCE_SUCCESS,
  CREATE_USER_PREFERENCE_FAILED,
} from "./constants";
export const initialState = {
  loading: false,
  prefLoading: false,
  getUserPreferences: [],
  getEmailTemplates: [],
};

export default function UserPreferencesStore(state = initialState, action) {
  switch (action.type) {
    case GET_USER_PREFERENCES_INIT:
      return { ...state, loading: true };
    case GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: false,
        getUserPreferences: action.payload,
      };
    case GET_USER_PREFERENCES_FAILED:
      return { ...state, loading: false };

    case GET_EMAIL_TEMPLATE_INIT:
      return { ...state, loading: true };
    case GET_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        getEmailTemplates: action.payload,
      };
    case GET_EMAIL_TEMPLATE_FAILED:
      return { ...state, loading: false };

    case CREATE_USER_PREFERENCE_INIT:
      return { ...state, prefLoading: true, getUserPreferences: [] };
    case CREATE_USER_PREFERENCE_SUCCESS:
      return {
        ...state,
        prefLoading: false,
        getUserPreferences: action.payload,
      };
    case CREATE_USER_PREFERENCE_FAILED:
      return { ...state, prefLoading: false };
    default:
      return state;
  }
}
